import { MessageSquare } from 'lucide-react'
import { cn } from '@/lib/utils'

interface MetricsDisplayProps {
  totalMessages?: number
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function MetricsDisplay({ totalMessages, className, size = 'md' }: MetricsDisplayProps) {
  const sizeConfig = {
    sm: {
      text: 'text-xs',
      icon: 'w-3 h-3',
      gap: 'gap-1',
    },
    md: {
      text: 'text-sm',
      icon: 'w-4 h-4',
      gap: 'gap-1.5',
    },
    lg: {
      text: 'text-base',
      icon: 'w-5 h-5',
      gap: 'gap-2',
    },
  }

  const config = sizeConfig[size]

  return (
    <div className={cn('flex items-center gap-4', className)}>
      <div className={cn('flex items-center', config.gap, 'text-muted-foreground')}>
        <MessageSquare className={config.icon} />
        <span className={cn('font-medium', config.text)}>
          {totalMessages ? totalMessages.toLocaleString('nl-NL') : 'onbekend'}
        </span>
        <span className={cn(config.text)}>berichten</span>
      </div>
    </div>
  )
}
